<template>
  <button type="button" @click="openModal" class="button button--green button--full-width">
      <Teleport to="#modals">
          <Transition name="modal-fade" appear>
              <BasketModal v-if="show" @close="hideModal" :price="price" :basket-url="basketUrl">
                <slot name="productRecommendations"></slot>
              </BasketModal>
          </Transition>
      </Teleport>
      Add To Basket
  </button>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import BasketModal from '../commerce/AddToBasketModal.vue';

const show = ref(false);

const props = defineProps({
  price: Number,
  basketUrl: String
});

watchEffect(() => {
  document.body.classList.toggle('noscroll', show.value);
});

const hideModal = () => {
  show.value = false;
};

const openModal = () => {
  show.value = true;
};

</script>
